export const ADD_ITEMS = 'ADD_ITEMS';
export const ADD_SINGLE_ITEM = 'ADD_SINGLE_ITEM';
export const UPDATE_ORDER_SUMMARY = 'UPDATE_ORDER_SUMMARY';
export const EMPTY_CART = 'EMPTY_CART';
export const TEMP_DOCUMENT = 'TEMP_DOCUMENT';
export const TEMP_DOCUMENT_DOCX = 'TEMP_DOCUMENT_DOCX';
export const EMPTY_CART_WHITOUT_DOCUMENT = 'EMPTY_CART_WHITOUT_DOCUMENT';
export const UPDATE_BUSINESS_COUPON = 'UPDATE_BUSINESS_COUPON';
